import { render, staticRenderFns } from "./GradientBar.vue?vue&type=template&id=fba1af58&scoped=true"
import script from "./GradientBar.vue?vue&type=script&lang=js"
export * from "./GradientBar.vue?vue&type=script&lang=js"
import style0 from "./GradientBar.vue?vue&type=style&index=0&id=fba1af58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba1af58",
  null
  
)

export default component.exports